import { createElement } from "react";
import React from "react";
import { equals, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { iterate, empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { join } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { Option_defaultOrMap } from "../Model/Prelude.js";
import { ofOption, handleEvent, clampIndex } from "./Prelude.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { tryItem, item, tryFindIndex, mapIndexed } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { toArray, unwrap, defaultArg } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { useLayoutEffect } from "../fable_modules/Feliz.2.9.0/ReactInterop.js";
import { createDisposable } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { op_UnaryNegation_Int32 } from "../fable_modules/fable-library-js.4.29.0/Int32.js";

export function selectControl(initialState, inputRef, props, state, setState) {
    let elems;
    return createElement("div", createObj(ofArray([["className", "select-control"], (elems = [createElement("input", createObj(toList(delay(() => append(singleton(["ref", inputRef]), delay(() => append(singleton(["aria-multiline", false]), delay(() => append((state.Hover != null) ? append(singleton(["aria-controls", join(" ", ["select-list"])]), delay(() => singleton(["aria-activedescendant", "selected-option"]))) : empty(), delay(() => append(singleton(["onBlur", (_arg) => {
        setState(initialState);
    }]), delay(() => {
        const matchValue = props.DisplayString;
        if (matchValue == null) {
            return append(singleton(["type", "text"]), delay(() => append(singleton(["inputMode", "none"]), delay(() => singleton(["readOnly", true])))));
        }
        else {
            const toString = matchValue;
            return append(singleton(["type", "search"]), delay(() => append(singleton(["placeholder", " "]), delay(() => append(singleton(["aria-autocomplete", "list"]), delay(() => append(singleton(["value", state.Search]), delay(() => singleton(["onChange", (ev) => {
                const str = ev.target.value;
                let options_1;
                let predicate;
                let f2_1;
                const text = str.toLocaleLowerCase();
                f2_1 = ((str_4) => (str_4.indexOf(text) >= 0));
                predicate = ((arg_1) => {
                    let str_1;
                    return f2_1((str_1 = toString(arg_1), str_1.toLocaleLowerCase()));
                });
                options_1 = props.Options.filter(predicate);
                setState({
                    Hover: Option_defaultOrMap(0, (index) => clampIndex(options_1, index), state.Hover),
                    Options: options_1,
                    Scroll: state.Scroll,
                    Search: str,
                });
            }])))))))));
        }
    })))))))))))), createElement("span", {
        style: {
            width: props.Width,
        },
        children: props.Display(props.Selected),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function selectList(listRef, clearHover, props, state, setState, hover) {
    return createElement("ul", createObj(toList(delay(() => append(singleton(["className", "select-list"]), delay(() => append(singleton(["id", "select-list"]), delay(() => append(singleton(["role", join(" ", ["listbox"])]), delay(() => append(singleton(["ref", listRef]), delay(() => append(singleton(["onMouseDown", (event) => {
        handleEvent(event);
    }]), delay(() => {
        let elems, elems_1;
        return (state.Options.length === 0) ? singleton((elems = [createElement("li", {
            className: "empty",
            "aria-hidden": true,
            children: "No results found...",
        })], ["children", reactApi.Children.toArray(Array.from(elems))])) : singleton((elems_1 = mapIndexed((i, opt) => {
            const active = hover === i;
            return createElement("li", createObj(toList(delay(() => append(active ? singleton(["id", "selected-option"]) : empty(), delay(() => append(singleton(["role", join(" ", ["option"])]), delay(() => append(singleton(["aria-selected", active]), delay(() => append(singleton(["onMouseDown", (e) => {
                if (e.button === 0) {
                    props.Dispatch(opt);
                    clearHover(e);
                }
            }]), delay(() => append(singleton(["onMouseMove", (_arg) => {
                if (!equals(state.Hover, i)) {
                    setState({
                        Hover: i,
                        Options: state.Options,
                        Scroll: false,
                        Search: state.Search,
                    });
                }
            }]), delay(() => singleton(["children", props.Display(opt)])))))))))))))));
        }, state.Options), ["children", reactApi.Children.toArray(Array.from(elems_1))]));
    }))))))))))))));
}

function Select(props) {
    let elems, children;
    const selectedIndex = defaultArg(tryFindIndex((y) => equals(props.Selected, y), props.Options), 0) | 0;
    const selectOffset = (e, offset) => {
        handleEvent(e);
        const index_1 = clampIndex(props.Options, selectedIndex + offset) | 0;
        if (index_1 !== selectedIndex) {
            props.Dispatch(item(index_1, props.Options));
        }
    };
    const initialState = {
        Options: props.Options,
        Scroll: false,
        Search: "",
    };
    const patternInput = reactApi.useState([initialState, initialState]);
    const state = patternInput[0][1];
    const prev = patternInput[0][0];
    const setState_1 = (next) => {
        patternInput[1]([state, next]);
    };
    const inputRef = reactApi.useRef(undefined);
    const listRef = reactApi.useRef(undefined);
    const dependencies = [props.Options];
    reactApi.useEffect(() => {
        setState_1({
            Hover: unwrap(initialState.Hover),
            Options: props.Options,
            Scroll: initialState.Scroll,
            Search: initialState.Search,
        });
    }, dependencies);
    useLayoutEffect((_arg) => {
        let list, i;
        const matchValue_2 = inputRef.current;
        let matchResult, input;
        if (prev.Hover == null) {
            if (state.Hover != null) {
                if (matchValue_2 != null) {
                    matchResult = 0;
                    input = matchValue_2;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0: {
                input.focus();
                break;
            }
        }
        const matchValue_5 = state.Hover;
        const matchValue_6 = listRef.current;
        let matchResult_1, list_1, i_1, list_2;
        if (prev.Hover != null) {
            if (matchValue_5 != null) {
                if (matchValue_6 != null) {
                    if ((list = matchValue_6, (i = (matchValue_5 | 0), state.Scroll))) {
                        matchResult_1 = 1;
                        i_1 = matchValue_5;
                        list_2 = matchValue_6;
                    }
                    else {
                        matchResult_1 = 2;
                    }
                }
                else {
                    matchResult_1 = 2;
                }
            }
            else {
                matchResult_1 = 2;
            }
        }
        else if (matchValue_5 != null) {
            if (matchValue_6 != null) {
                matchResult_1 = 0;
                list_1 = matchValue_6;
            }
            else {
                matchResult_1 = 2;
            }
        }
        else {
            matchResult_1 = 2;
        }
        switch (matchResult_1) {
            case 0: {
                iterate((elm) => {
                    const listBounds = list_1.getBoundingClientRect();
                    const itemBounds = elm.getBoundingClientRect();
                    list_1.scrollTop = ((itemBounds.top - listBounds.top) - ((listBounds.height - itemBounds.height) / 2));
                }, toArray(list_1.children.item(selectedIndex)));
                break;
            }
            case 1: {
                iterate((elm_1) => {
                    const listBounds_1 = list_2.getBoundingClientRect();
                    const itemBounds_1 = elm_1.getBoundingClientRect();
                    if (itemBounds_1.top < listBounds_1.top) {
                        list_2.scrollBy(0, itemBounds_1.top - listBounds_1.top);
                    }
                    else if (itemBounds_1.bottom > listBounds_1.bottom) {
                        list_2.scrollBy(0, itemBounds_1.bottom - listBounds_1.bottom);
                    }
                }, toArray(list_2.children.item(i_1)));
                break;
            }
        }
        return createDisposable(() => {
        });
    });
    const setHover = (e_1, index_2) => {
        handleEvent(e_1);
        const index_3 = index_2;
        if (!equals(state.Hover, index_3)) {
            setState_1({
                Hover: unwrap(index_3),
                Options: state.Options,
                Scroll: true,
                Search: state.Search,
            });
        }
    };
    const setHoverOffset = (e_2, hover, offset_1) => {
        setHover(e_2, clampIndex(state.Options, hover + offset_1));
    };
    const clearHover = (e_3) => {
        handleEvent(e_3);
        setState_1(initialState);
    };
    return createElement("div", createObj(ofArray([["className", "select"], ["role", join(" ", ["combobox"])], ["aria-expanded", state.Hover != null], ["onMouseDown", (e_4) => {
        if (e_4.button === 0) {
            if (state.Hover != null) {
                clearHover(e_4);
            }
            else {
                setHover(e_4, selectedIndex);
            }
        }
    }], ["onKeyDown", (e_5) => {
        const matchValue_8 = e_5.key;
        const matchValue_9 = state.Hover;
        let matchResult_2, hover_1;
        switch (matchValue_8) {
            case "Escape": {
                if (matchValue_9 != null) {
                    matchResult_2 = 0;
                }
                else {
                    matchResult_2 = 16;
                }
                break;
            }
            case " ": {
                if (matchValue_9 == null) {
                    matchResult_2 = 8;
                }
                else {
                    matchResult_2 = 1;
                    hover_1 = matchValue_9;
                }
                break;
            }
            case "Enter": {
                if (matchValue_9 == null) {
                    matchResult_2 = 8;
                }
                else {
                    matchResult_2 = 1;
                    hover_1 = matchValue_9;
                }
                break;
            }
            case "Tab": {
                if (matchValue_9 != null) {
                    matchResult_2 = 1;
                    hover_1 = matchValue_9;
                }
                else {
                    matchResult_2 = 16;
                }
                break;
            }
            case "ArrowUp": {
                if (matchValue_9 == null) {
                    matchResult_2 = 9;
                }
                else {
                    matchResult_2 = 2;
                }
                break;
            }
            case "ArrowDown": {
                if (matchValue_9 == null) {
                    matchResult_2 = 8;
                }
                else {
                    matchResult_2 = 3;
                }
                break;
            }
            case "PageUp": {
                if (matchValue_9 == null) {
                    matchResult_2 = 12;
                }
                else {
                    matchResult_2 = 4;
                }
                break;
            }
            case "PageDown": {
                if (matchValue_9 == null) {
                    matchResult_2 = 13;
                }
                else {
                    matchResult_2 = 5;
                }
                break;
            }
            case "Home": {
                if (matchValue_9 == null) {
                    matchResult_2 = 14;
                }
                else {
                    matchResult_2 = 6;
                }
                break;
            }
            case "End": {
                if (matchValue_9 == null) {
                    matchResult_2 = 15;
                }
                else {
                    matchResult_2 = 7;
                }
                break;
            }
            case "ArrowLeft": {
                if (matchValue_9 == null) {
                    matchResult_2 = 10;
                }
                else {
                    matchResult_2 = 16;
                }
                break;
            }
            case "ArrowRight": {
                if (matchValue_9 == null) {
                    matchResult_2 = 11;
                }
                else {
                    matchResult_2 = 16;
                }
                break;
            }
            default:
                matchResult_2 = 16;
        }
        switch (matchResult_2) {
            case 0: {
                clearHover(e_5);
                break;
            }
            case 1: {
                if ((e_5.key !== " ") ? true : (props.DisplayString == null)) {
                    iterate(props.Dispatch, toArray(tryItem(hover_1, state.Options)));
                    clearHover(e_5);
                }
                break;
            }
            case 2: {
                const arg_6 = matchValue_9 | 0;
                setHoverOffset(e_5, arg_6, -1);
                break;
            }
            case 3: {
                const arg_9 = matchValue_9 | 0;
                setHoverOffset(e_5, arg_9, 1);
                break;
            }
            case 4: {
                const arg_12 = matchValue_9 | 0;
                const arg_13 = op_UnaryNegation_Int32(10) | 0;
                setHoverOffset(e_5, arg_12, arg_13);
                break;
            }
            case 5: {
                const arg_15 = matchValue_9 | 0;
                setHoverOffset(e_5, arg_15, 10);
                break;
            }
            case 6: {
                const arg_18 = matchValue_9 | 0;
                const arg_19 = op_UnaryNegation_Int32(state.Options.length) | 0;
                setHoverOffset(e_5, arg_18, arg_19);
                break;
            }
            case 7: {
                const arg_21 = matchValue_9 | 0;
                const arg_22 = state.Options.length | 0;
                setHoverOffset(e_5, arg_21, arg_22);
                break;
            }
            case 8: {
                if ((e_5.key !== " ") ? true : (props.DisplayString == null)) {
                    setHover(e_5, selectedIndex);
                }
                break;
            }
            case 9: {
                setHover(e_5, 0);
                break;
            }
            case 10: {
                selectOffset(e_5, -1);
                break;
            }
            case 11: {
                selectOffset(e_5, 1);
                break;
            }
            case 12: {
                const arg_32 = op_UnaryNegation_Int32(10) | 0;
                selectOffset(e_5, arg_32);
                break;
            }
            case 13: {
                selectOffset(e_5, 10);
                break;
            }
            case 14: {
                const arg_36 = op_UnaryNegation_Int32(props.Options.length) | 0;
                selectOffset(e_5, arg_36);
                break;
            }
            case 15: {
                const arg_38 = props.Options.length | 0;
                selectOffset(e_5, arg_38);
                break;
            }
            case 16: {
                break;
            }
        }
    }], (elems = [(children = ofArray([selectControl(initialState, inputRef, props, state, setState_1), ofOption((hover_8) => selectList(listRef, (arg_39) => {
        clearHover(arg_39);
    }, props, state, setState_1, hover_8), state.Hover)]), createElement("div", {
        children: reactApi.Children.toArray(Array.from(children)),
    })), createElement("img", {
        alt: "",
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function ignoreSame(selected, dispatch, value) {
    if (!equals(selected, value)) {
        dispatch(value);
    }
}

export function search(width, toString, display, options_1, selected, dispatch) {
    return createElement(Select, {
        Dispatch: (value) => {
            ignoreSame(selected, dispatch, value);
        },
        Display: display,
        DisplayString: toString,
        Options: options_1,
        Selected: selected,
        Width: width,
    });
}

export function options(width, display, options_1, selected, dispatch) {
    return createElement(Select, {
        Dispatch: (value) => {
            ignoreSame(selected, dispatch, value);
        },
        Display: display,
        Options: options_1,
        Selected: selected,
        Width: width,
    });
}

//# sourceMappingURL=Select.js.map
